import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import PropTypes from 'prop-types';

export const subjectsPropType = PropTypes.oneOf(Object.values(SUBJECTS_SLUGS));

export const subjectPropType = PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    slug: subjectsPropType,
});

export const loadedSubjectPropType = PropTypes.shape({
    name: PropTypes.string,
    subject: subjectsPropType,
});
